import { Currency, SOL_DECIMALS, USDC_DECIMALS } from '@solante/shared';

const currencyDecimals: Record<Currency, number> = {
  SOL: SOL_DECIMALS,
  USDC: USDC_DECIMALS,
};

export const lamportsToAmount = (lamports: bigint, currency: Currency): number => {
  const decimals = currencyDecimals[currency];
  return Number(lamports) / 10 ** decimals;
};

export const amountToLamports = (amount: number, currency: Currency): bigint => {
  const decimals = currencyDecimals[currency];
  return BigInt(Math.round(amount * 10 ** decimals));
};

export const formatCurrency = (amount: number, currency: Currency): string => {
  return `${amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency}`;
};

export const shortKey = (key?: string) => {
  if (!key) return '';
  return `${key.slice(0, 4)}…${key.slice(-4)}`;
};

export const formatLamports = (lamports: bigint, currency: Currency) =>
  formatCurrency(lamportsToAmount(lamports, currency), currency);

export const normalizeLamports = (value: unknown): bigint => {
  if (typeof value === 'bigint') return value;
  if (typeof value === 'number') return BigInt(Math.round(value));
  if (typeof value === 'string') return BigInt(value);
  throw new Error('Unsupported lamports value');
};
